import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./Cupao.module.css";
import load from "../../../../../Images/loading.gif";
import EditModal from "./EditModal/EditModal";

function Cupao() {
    const { coupon_code } = useParams();
    const [coupon, setCoupon] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchCoupon = useCallback(async () => {
        try {
            const response = await fetch(`https://eclipsebots.com/api/coupons/${coupon_code}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include"
            });

            if (!response.ok) {
                throw new Error("Failed to fetch cupão");
            }

            const data = await response.json();
            setCoupon(data[0]);
        } catch (error) {
            console.error("Erro ao buscar cupão:", error);
            setCoupon(null);
        } finally {
            setLoading(false);
        }
    }, [coupon_code]); // <- Aqui só colocas as dependências que a função usa

    useEffect(() => {
        fetchCoupon();
    }, [fetchCoupon]);

    const handleUpdateCoupon = async (coupon) => {
        try {
            const response = await fetch("https://eclipsebots.com/api/coupons/atualizar", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify(coupon),
            });

            const data = await response.json();

            if (!response.ok) {
                console.error("Erro ao atualizar:", data.message);
            } else {
                console.log("Cupom atualizado com sucesso");
            }

            fetchCoupon();
        } catch (error) {
            console.error("Erro na requisição de update:", error);
        }
    };


    const handleDeleteCoupon = async () => {
        const confirmDelete = window.confirm("Tens a certeza que queres apagar este cupom?");
        if (!confirmDelete) return;

        try {
            const response = await fetch(`https://eclipsebots.com/api/coupons/delete/${coupon_code}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include"
            });

            if (!response.ok) {
                throw new Error("Erro ao apagar cupom");
            }

            fetchCoupon();
        } catch (error) {
            console.error("Erro ao apagar cupom:", error);
        }
    };

    const toggleIsEditing = async () => {
        setIsEditing(!isEditing);
    }

    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    if (!coupon) {
        return <div className={styles.noData}>Cupão não encontrado.</div>;
    }

    const createdDate = new Date(coupon.created);
    let created = createdDate.toLocaleString("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).replace(",", " |");
    let exp = "Sem expiração";
    if (coupon.expiration_date !== null) {
        const expDate = new Date(coupon.expiration_date);
        exp = expDate.toLocaleString("pt-PT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        }).replace(",", " |");
    }

    return (
        <div className={styles.coupons}>
            <EditModal isOpen={isEditing} coupon={coupon} onUpdate={handleUpdateCoupon} onClose={() => setIsEditing(false)} />
            <div className={`${styles.coupon} ${styles.first} ${styles.last}`}>
                <div className={styles.header}>
                    <div className={`${styles.name} ${styles.imagem}`}>
                        <div>{coupon.coupon_code}</div>
                        <div><span>{coupon.discount_type === "percentage" ? `${coupon.discount_value}%` : `R$${coupon.discount_value}`}</span></div>
                    </div>
                </div>
                <div>
                    <div className={styles.topic}>
                                <span className={styles.title}>Tipo:</span> {coupon.discount_type === "percentage" ? "%" : "R$"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Máximo de Usos:</span> {coupon.max_uses || "Ilimitado"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Usos:</span> {coupon.uses}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Expiração:</span> {exp}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Serviços aplicaveis:</span> {coupon.applicable_services === null ? "Todos" : `${coupon.applicable_services}`}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Cargos Exclusivos:</span> {coupon.exclusive_role === null ? "Nenhum" : `${coupon.exclusive_roles}`}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Primeira Compra:</span> {coupon.first_purchase === 0 ? "Não" : "Sim"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Status:</span>
                        <span className={`status ${coupon.is_active === 0 ? styles.inativo : styles.ativo}`}>
                            {coupon.is_active === 0 ? "INATIVO" : "ATIVO"}
                        </span>
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Valor Minimo:</span> {coupon.minimum_purchase_value === 0 ? "Sem valor minimo" : `${coupon.minimum_purchase_value}`}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Parceiro:</span> {coupon.partner === 0 ? "Não" : "Sim"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Criado:</span> {created}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Valor Gerado:</span> R${coupon.revenue}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Id do Autor:</span> {coupon.authorId}
                    </div>
                    <div className={`${styles.topic} ${styles.bottom}`}>
                        <button onClick={() => toggleIsEditing()}>✏️ Editar</button>
                    </div>
                    <div className={`${styles.topic} ${styles.bottom}`}>
                        <button onClick={() => handleDeleteCoupon()}>🗑️ Apagar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cupao;
